import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Row,
    Col,
} from "reactstrap";
import styles from './styles.module.scss';
import Link from 'next/link';
import { Fancybox } from "@fancyapps/ui";
// Version 4.0.31
import "@fancyapps/ui/dist/fancybox.css";
//https://www.npmjs.com/package/@fancyapps/ui
import PlayIcon from "/public/site-assets/svg/play.svg"

export default function ImageWithText({
    global,
    pathPrefix,
    customClass = "",
    content,
    imageUrl,
    imageAlt,
    label,
    videoLink,
    video_category
}) {
    return (
        <>
            <section className={`${styles.root} ${customClass}`} >
                <Container>
                    <Row>
                        <Col lg={6} className="ps-lg-5 pe-lg-5 mt-md-5 mb-4 mb-lg-0">
                            <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">{content}</SourceFlowText>
                        </Col>
                        <Col lg={6} className="ps-lg-5">
                            {videoLink ?
                                <a
                                    className="fancy-box position-relative d-block overflow-hidden shadow rounded-3"
                                    data-fancybox={video_category}
                                    data-type={"iframe"}
                                    href={videoLink}
                                >
                                    <div className="position-relative rounded-3 overflow-hidden">
                                        <span className="play position-absolute d-inline-block p-3">
                                            <PlayIcon />
                                        </span>
                                        <span className="label position-absolute d-inline-block p-1 py-md-2 px-md-3 rounded-3 text-white">
                                            <SourceFlowText global={global} path={`${pathPrefix}.label`}>{label}</SourceFlowText>
                                        </span>
                                        <SourceFlowImage
                                            src={imageUrl}
                                            size="1000x1000"
                                            alt={imageAlt}
                                            className="card-img position-relative"
                                            width="100%"
                                            height="auto"
                                        />
                                    </div></a> :
                                <div className="position-relative shadow">
                                    <span className="label position-absolute d-inline-block pt-2 pb-2 ps-3 pe-3 rounded-3 text-white">
                                        <SourceFlowText global={global} path={`${pathPrefix}.label`}>{label}</SourceFlowText>
                                    </span>
                                    <SourceFlowImage
                                        src={imageUrl}
                                        size="1000x1000"
                                        alt={imageAlt}
                                        className="card-img rounded-3 overflow-hidden"
                                        width="100%"
                                        height="auto"
                                    />
                                </div>}
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}